import React from 'react';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';



const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
        <text x={x} y={y} fill="#1e3a5f" textAnchor="middle" dominantBaseline="central" className="text-sm font-semibold">
            {`${(percent * 100).toFixed(0)}%`}
        </text>
    );
};

const FNOLProcessedChart = ({ stats, distributionData, loading }) => {
    // Use distribution data from API if available, otherwise fall back to stats
    const data = distributionData && distributionData.distribution 
        ? distributionData.distribution.map(item => ({
            name: item.label,
            value: item.count,
            color: item.status === 'new' ? '#CEE7FB' : 
                   item.status === 'open' ? '#72C6FF' : '#A2D1F4'
        }))
        : [
            { name: 'Open', value: stats?.open || 0, color: '#72C6FF' },
            { name: 'New', value: stats?.new || 0, color: '#CEE7FB' },
            { name: 'Processed', value: stats?.processed || 0, color: '#A2D1F4' },
        ];

    if (loading) {
        return (
            <div className="h-[380px] flex flex-col items-center justify-center">
                <h2 className="text-xl font-bold text-gray-900 mb-6">FNOL Processed</h2>
                <div className="text-gray-500">Loading...</div>
            </div>
        );
    }

    return (
        <div className="h-full flex flex-col items-center">
            <h2 className="text-xl font-bold text-gray-900 mb-4">FNOL Processed</h2>
            <div className="w-full h-[380px]">
                <ResponsiveContainer width="100%" height="100%">
                    <PieChart>
                        <Pie
                            data={data}
                            cx="50%"
                            cy="50%"
                            labelLine={false}
                            label={renderCustomizedLabel}
                            outerRadius={145}
                            fill="#8884d8"
                            dataKey="value"
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.color} stroke="white" strokeWidth={2} />
                            ))}
                        </Pie>
                        <Tooltip />
                        <Legend
                            layout="horizontal"
                            verticalAlign="bottom"
                            align="center"
                            iconType="square"
                            wrapperStyle={{ paddingTop: '12px' }}
                            formatter={(value) => <span className="text-gray-700 font-medium ml-1">{value}</span>}
                        />
                    </PieChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
};

export default FNOLProcessedChart;
